import { Injectable } from '@angular/core';

import { ErrorService } from '@services/error.service';
import { PartyService } from './party.service';
import { HttpService } from './http.service';

import { PdfCatalog } from '@models/pdf-catalog';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  constructor(
    private errorService: ErrorService,
    private partyService: PartyService,
    private httpService: HttpService,
  ) { }

  public updatePartyEnabled(
    enabled: boolean,
    partyId?: string,
  ): Promise<void> {
    return this.partyService.updateParty({
      enabled: (enabled ? 'Y' : 'N'),
      partyId,
    });
  }

  public fetchFunctionsInfo(): Promise<any[] | null> {
    return new Promise((resolve, reject) => {
      return this.httpService.get(`**/admin/getAzureFunctionsInfo`).then((functionsInfo: any[]) => {
        functionsInfo = functionsInfo.map((item: any) => {
          item.lastStart = item.lastStart ? new Date(item.lastStart) : null;
          item.lastStop = item.lastStop ? new Date(item.lastStop) : null;
          return item;
        });
        return resolve(functionsInfo);
      }).catch((error: any) => {
        this.errorService.printError(error);
        return reject(error);
      });
    })
  }

  public getPdfCatalogs(): Promise<PdfCatalog[]> {
    return new Promise((resolve, reject) => {
      return this.httpService.get('**/admin/getPdfCatalogs').then((dataCatalogs: any[]) => {
        return resolve(dataCatalogs);
      }).catch((err) => {
        this.errorService.printError(err);
        return reject();
      })
    })
  }

  public uploadPdfCatalogSource(file: File, options: any): Promise<string | null> {
    if (!file) {
      return Promise.reject();
    }

    return new Promise((resolve, reject) => {
      let formData = new FormData();
      formData.append('file', file);
      formData.append('options', JSON.stringify(options || {}));

      return this.httpService.post(`**/admin/uploadPdfCatalogSource`, formData, { fullResponse: true }).then(() => {
        return resolve(null);
      }).catch((error: HttpErrorResponse) => {
        console.error('postFile error:', error);
        this.errorService.printError(error);
        return reject(error);
      });
    });
  }

}
